import Icon from '../components/Icon.vue'

Icon.register({
  tired: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM281.8 197.7c-7.7 4.7-7.7 15.9 0 20.6l80 48c11.5 6.8 24.1-7.6 15.4-18l-33.6-40.3 33.6-40.3c8.6-10.3-3.8-24.9-15.4-18zM118.8 167.7l33.6 40.3-33.6 40.3c-8.6 10.4 3.9 24.8 15.4 18l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18zM248 288c-51.9 0-115.3 43.8-123.2 106.7-1.7 13.4 7.9 24.6 17.7 20.4 25.9-11.1 64.4-17.4 105.5-17.4s79.6 6.3 105.5 17.4c9.7 4.2 19.4-6.8 17.7-20.4-7.9-62.9-71.3-106.7-123.2-106.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tired.js
// module id = 2012
// module chunks = 0